import { render, staticRenderFns } from "./AIVTable.vue?vue&type=template&id=e69825ba&scoped=true"
import script from "./AIVTable.vue?vue&type=script&lang=js"
export * from "./AIVTable.vue?vue&type=script&lang=js"
import style0 from "./AIVTable.vue?vue&type=style&index=0&id=e69825ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e69825ba",
  null
  
)

export default component.exports